/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

import * as React from "react";
import { createUseScreenVariants } from "@plasmicapp/react-web";

export type Theme2Value = "dark";
export const Theme2Context = React.createContext<Theme2Value | undefined>(
  "PLEASE_RENDER_INSIDE_PROVIDER" as any
);
export function Theme2ContextProvider(
  props: React.PropsWithChildren<{ value: Theme2Value | undefined }>
) {
  return (
    <Theme2Context.Provider value={props.value}>
      {props.children}
    </Theme2Context.Provider>
  );
}

export function useTheme2() {
  return React.useContext(Theme2Context);
}

export default Theme2Context;
/* prettier-ignore-end */
